import { AnalyticsActions } from './slice';
import { AnalyticsEvent } from './stateType';

export const sendAnalyticsEvent = AnalyticsActions.sendEvent as (
  payload: Partial<AnalyticsEvent>,
) => void;
